import { Switch, Route } from 'react-router-dom';
import { lazy } from 'react';
import Loadable from '../components/common/Loadable';
import { ROUTES } from '../constants';

const ElectricDefault = Loadable(lazy(() => import('../views/electric')));
const ElectricBillingDefault = Loadable(lazy(() => import('../views/electric/billing')));
const ElectricBillingDetailDefault = Loadable(lazy(() => import('../views/electric/billing/[id]')));
const ElectricTestDefault = Loadable(lazy(() => import('../views/electric/test')));
const ElectricUsageDefault = Loadable(lazy(() => import('../views/electric/usage')));
const ElectricEmailSettingDefault = Loadable(lazy(() => import('../views/electric/emailSetting')));
const ElectricProfileSettingDefault = Loadable(lazy(() => import('../views/electric/profile')));
const ElectricListContractDefault = Loadable(lazy(() => import('../views/electric/contract')));
const ElectricContractDetailDefault = Loadable(lazy(() => import('../views/electric/contract/[id]')));
const ElectricNoticeDetailDefault = Loadable(lazy(() => import('../views/electric/notice/[id]')));
const ElectricListNoticeDefault = Loadable(lazy(() => import('../views/electric/notice')));
const DRScheduleListDefault = Loadable(lazy(() => import('../views/electric/drSchedule')));
const DRScheduleDetailDefault = Loadable(lazy(() => import('../views/electric/drSchedule/[id]')));
const ProcedureDefault = Loadable(lazy(() => import('../views/electric/procedure')));
const InquiryDefault = Loadable(lazy(() => import('../views/inquiry')));
const ChangePasswordDefault = Loadable(lazy(() => import('../views/electric/changePassword')));
const EditEmailDefault = Loadable(lazy(() => import('../views/electric/editEmail')));
const EditPhoneDefault = Loadable(lazy(() => import('../views/electric/editPhone')));
const EditAgentInfoDefault = Loadable(lazy(() => import('../views/electric/editAgentInfo')));
const FaqDefault = Loadable(lazy(() => import('../views/electric/faq')));

const ElectricRoutes = () => (
    <Switch>
        <Route path={ROUTES.ELECTRIC.BASE} exact component={ElectricDefault} />
        <Route path={ROUTES.ELECTRIC.BILLING_DETAIL} component={ElectricBillingDetailDefault} />
        <Route path={ROUTES.ELECTRIC.BILLING} component={ElectricBillingDefault} />
        <Route path={ROUTES.ELECTRIC.TEST} component={ElectricTestDefault} />
        <Route path={ROUTES.ELECTRIC.USAGE} component={ElectricUsageDefault} />
        <Route path={ROUTES.ELECTRIC.EMAIL_SETTING} component={ElectricEmailSettingDefault} />
        <Route path={ROUTES.ELECTRIC.PROFILE} component={ElectricProfileSettingDefault} />
        <Route path={ROUTES.ELECTRIC.CONTRACT_DETAIL} component={ElectricContractDetailDefault} />
        <Route path={ROUTES.ELECTRIC.CONTRACT} component={ElectricListContractDefault} />
        <Route path={ROUTES.ELECTRIC.NOTICE_DETAIL} component={ElectricNoticeDetailDefault} />
        <Route path={ROUTES.ELECTRIC.NOTICE} component={ElectricListNoticeDefault} />
        <Route path={ROUTES.ELECTRIC.DR_SCHEDULE_DETAIL} component={DRScheduleDetailDefault} />
        <Route path={ROUTES.ELECTRIC.DR_SCHEDULE} component={DRScheduleListDefault} />
        <Route path={ROUTES.ELECTRIC.PROCEDURE} component={ProcedureDefault} />
        <Route path={ROUTES.ELECTRIC.INQUIRY} component={InquiryDefault} />
        <Route path={ROUTES.ELECTRIC.CHANGE_PASSWORD} component={ChangePasswordDefault} />
        <Route path={ROUTES.ELECTRIC.EDIT_EMAIL} component={EditEmailDefault} />
        <Route path={ROUTES.ELECTRIC.EDIT_PHONE} component={EditPhoneDefault} />
        <Route path={ROUTES.ELECTRIC.EDIT_AGENT_INFO} component={EditAgentInfoDefault} />
        <Route path={ROUTES.ELECTRIC.FAQ} component={FaqDefault} />
    </Switch>
);

export default ElectricRoutes;
